// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__1boo_","description":"PatientConsentPreview_description__3p8Qu"};